<template>
    <div>
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">On-Site Support for Critical Operations Across South Texas</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white"><router-link to="/">Home</router-link></li>
                                            <li class="text-white active">Service Area</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Start Content -->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2>Your Local IT Partner, Wherever Your Operation Is</h2>
                        <p>Cyber Nexus Solutions is a Laredo-based company dedicated to serving the businesses that drive the South Texas economy. We have the team and equipment to provide expert on-site support for projects, emergencies, and ongoing management across the region. We specialize in supporting distributed, multi-site, and remote operations where reliable local support is essential.</p>
                        
                        <h2>Primary Service Areas</h2>
                        <p>While we can provide remote support to any location, our primary on-site service area is centered around the I-35 corridor and the Eagle Ford Shale. This includes, but is not limited to:</p>
                        <ul>
                            <li>Laredo (Webb County)</li>
                            <li>Cotulla (La Salle County)</li>
                            <li>Carrizo Springs (Dimmit County)</li>
                            <li>Dilley (Frio County)</li>
                            <li>Encinal (La Salle County)</li>
                            <li>Catarina (Dimmit County)</li>
                            <li>And other South Texas communities.</li>
                        </ul>
                        <p>If your operation is in South Texas but you don't see your specific location listed, please contact us. We are equipped to travel to remote and industrial sites throughout the area.</p>

                        <h2>Our Full Suite of Services for Your South Texas Operation</h2>
                        <p>No matter your location, you have access to our complete range of expert services for critical operations:</p>
                        <ul>
                            <li><strong>Network Protection & Firewalls:</strong> On-site deployment and configuration of business-grade firewalls and secure networks.</li>
                            <li><strong>Managed IT Services:</strong> Proactive remote monitoring combined with responsive on-site support when you need it.</li>
                            <li><strong>Oilfield & Remote Site IT:</strong> Field-level support for connectivity, SCADA networking, and rugged communication systems.</li>
                            <li><strong>Camera & NVR Networks:</strong> Professional installation of video surveillance systems at commercial and industrial facilities.</li>
                        </ul>

                        <h3>Ready to discuss your project?</h3>
                        <router-link to="/contact">Request a consultation to schedule on-site service or a site review.</router-link>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Content -->
    </div>
</template>
<script>
    export default {
        name: 'ServiceArea'
    }
</script>
